import React from "react";

import search from "../../images/icons/search.png"
import update from "../../images/icons/update.png"

import { BsArrowUp, BsChevronDoubleRight } from "react-icons/bs";

import { Link } from "react-router-dom";

const Users = [
    {
        id: "100 002 939 293 120",
        selected: false,
        wallboxSerial: "POJ-103949543129",
        Dateinstalled: "2021-10-26",
        timeD: "13:07:42",
        endDate: "-",
        endTime: "-",
        duration: "01:33h",
        energy: "33 kW",
        User: "Julian Leudesdorff",
        Konto: "Geschäftlich",
        Status: "Ongoing",
    },
    {
        id: "100 002 939 293 120",
        selected: false,
        wallboxSerial: "POJ-103949543129",
        Dateinstalled: "2021-10-26",
        timeD: "13:07:42",
        endDate: "2021-10-26",
        endTime: "19:32:16",
        duration: "01:33h",
        energy: "33 kW",
        User: "Jonas Moßler",
        Konto: "Geschäftlich",
        Status: "Finished",
    },
    {
        id: "100 002 939 293 120",
        selected: false,
        wallboxSerial: "POJ-103949543129",
        Dateinstalled: "2021-10-26",
        timeD: "13:07:42",
        endDate: "2021-10-26",
        endTime: "19:32:16",
        duration: "01:33h",
        energy: "33 kW",
        User: "Jonas Moßler",
        Konto: "Geschäftlich",
        Status: "Finished",
    },
    {
        id: "100 002 939 293 120",
        selected: false,
        wallboxSerial: "POJ-103949543129",
        Dateinstalled: "2021-10-26",
        timeD: "13:07:42",
        endDate: "2021-10-26",
        endTime: "19:32:16",
        duration: "01:33h",
        energy: "33 kW",
        User: "Jonas Moßler",
        Konto: "Geschäftlich",
        Status: "Finished",
    },
    {
        id: "100 002 939 293 120",
        selected: false,
        wallboxSerial: "POJ-103949543129",
        Dateinstalled: "2021-10-26",
        timeD: "13:07:42",
        endDate: "2021-10-26",
        endTime: "19:32:16",
        duration: "01:33h",
        energy: "33 kW",
        User: "Jonas Moßler",
        Konto: "Geschäftlich",
        Status: "Finished",
    },
    {
        id: "100 002 939 293 120",
        selected: false,
        wallboxSerial: "POJ-103949543129",
        Dateinstalled: "2021-10-26",
        timeD: "13:07:42",
        endDate: "2021-10-26",
        endTime: "19:32:16",
        duration: "01:33h",
        energy: "33 kW",
        User: "Jonas Moßler",
        Konto: "Geschäftlich",
        Status: "Finished",
    },
    {
        id: "100 002 939 293 120",
        selected: false,
        wallboxSerial: "POJ-103949543129",
        Dateinstalled: "2021-10-26",
        timeD: "13:07:42",
        endDate: "2021-10-26",
        endTime: "19:32:16",
        duration: "01:33h",
        energy: "33 kW",
        User: "Jonas Moßler",
        Konto: "Geschäftlich",
        Status: "Finished",
    },
    {
        id: "100 002 939 293 120",
        selected: false,
        wallboxSerial: "POJ-103949543129",
        Dateinstalled: "2021-10-26",
        timeD: "13:07:42",
        endDate: "2021-10-26",
        endTime: "19:32:16",
        duration: "01:33h",
        energy: "33 kW",
        User: "Jonas Moßler",
        Konto: "Geschäftlich",
        Status: "Finished",
    },
    {
        id: "100 002 939 293 120",
        selected: false,
        wallboxSerial: "POJ-103949543129",
        Dateinstalled: "2021-10-26",
        timeD: "13:07:42",
        endDate: "2021-10-26",
        endTime: "19:32:16",
        duration: "01:33h",
        energy: "33 kW",
        User: "Jonas Moßler",
        Konto: "Geschäftlich",
        Status: "Finished",
    },
    {
        id: "100 002 939 293 120",
        selected: false,
        wallboxSerial: "POJ-103949543129",
        Dateinstalled: "2021-10-26",
        timeD: "13:07:42",
        endDate: "2021-10-26",
        endTime: "19:32:16",
        duration: "01:33h",
        energy: "33 kW",
        User: "Jonas Moßler",
        Konto: "Geschäftlich",
        Status: "Finished",
    },
    {
        id: "100 002 939 293 120",
        selected: false,
        wallboxSerial: "POJ-103949543129",
        Dateinstalled: "2021-10-26",
        timeD: "13:07:42",
        endDate: "2021-10-26",
        endTime: "19:32:16",
        duration: "01:33h",
        energy: "33 kW",
        User: "Jonas Moßler",
        Konto: "Geschäftlich",
        Status: "Finished",
    },
    {
        id: "100 002 939 293 120",
        selected: false,
        wallboxSerial: "POJ-103949543129",
        Dateinstalled: "2021-10-26",
        timeD: "13:07:42",
        endDate: "2021-10-26",
        endTime: "19:32:16",
        duration: "01:33h",
        energy: "33 kW",
        User: "Jonas Moßler",
        Konto: "Geschäftlich",
        Status: "Finished",
    },
    {
        id: "100 002 939 293 120",
        selected: false,
        wallboxSerial: "POJ-103949543129",
        Dateinstalled: "2021-10-26",
        timeD: "13:07:42",
        endDate: "2021-10-26",
        endTime: "19:32:16",
        duration: "01:33h",
        energy: "33 kW",
        User: "Jonas Moßler",
        Konto: "Geschäftlich",
        Status: "Finished",
    },
    {
        id: "100 002 939 293 120",
        selected: false,
        wallboxSerial: "POJ-103949543129",
        Dateinstalled: "2021-10-26",
        timeD: "13:07:42",
        endDate: "2021-10-26",
        endTime: "19:32:16",
        duration: "01:33h",
        energy: "33 kW",
        User: "Jonas Moßler",
        Konto: "Geschäftlich",
        Status: "Finished",
    },
    {
        id: "100 002 939 293 120",
        selected: false,
        wallboxSerial: "POJ-103949543129",
        Dateinstalled: "2021-10-26",
        timeD: "13:07:42",
        endDate: "2021-10-26",
        endTime: "19:32:16",
        duration: "01:33h",
        energy: "33 kW",
        User: "Jonas Moßler",
        Konto: "Geschäftlich",
        Status: "Finished",
    },
    {
        id: "100 002 939 293 120",
        selected: false,
        wallboxSerial: "POJ-103949543129",
        Dateinstalled: "2021-10-26",
        timeD: "13:07:42",
        endDate: "2021-10-26",
        endTime: "19:32:16",
        duration: "01:33h",
        energy: "33 kW",
        User: "Jonas Moßler",
        Konto: "Geschäftlich",
        Status: "Finished",
    },


];

// Sorting function
const sortedList = (data, order, item) => {
    if (order === 'up') {
        return data.sort((a, b) => (a[item] ? 1 : -1));
    }
    if (order === 'down') {
        return data.sort((a, b) => (a[item] ? -1 : 1));
    }
}

class ChargeEventData extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            List: Users,
            MasterChecked: false,
            SelectedList: [],
            show: false,
            currentSort: 'up'
        };
    }

    handleModal() {
        this.setState({ show: !this.state.show })
    }

    // Select/ UnSelect Table rows
    onMasterCheck(e) {
        let tempList = this.state.List;
        // Check/ UnCheck All Items
        tempList.map((user) => (user.selected = e.target.checked));

        //Update State
        this.setState({
            MasterChecked: e.target.checked,
            List: tempList,
            SelectedList: this.state.List.filter((e) => e.selected),
        });
    }

    // Update List Item's state and Master Checkbox State
    onItemCheck(e, item) {
        let tempList = this.state.List;
        tempList.map((user) => {
            if (user.id === item.id) {
                user.selected = e.target.checked;
            }
            return user;
        });

        //To Control Master Checkbox State
        const totalItems = this.state.List.length;
        const totalCheckedItems = tempList.filter((e) => e.selected).length;

        // Update State
        this.setState({
            MasterChecked: totalItems === totalCheckedItems,
            List: tempList,
            SelectedList: this.state.List.filter((e) => e.selected),
        });
    }

    // Event to get selected rows(Optional)
    getSelectedRows() {
        this.setState({
            SelectedList: this.state.List.filter((e) => e.selected),
        });
    }

    onSortChange = () => {
        const { currentSort } = this.state;
        let nextSort;

        if (currentSort === 'down') nextSort = 'up';
        else if (currentSort === 'up') nextSort = 'down';

        this.setState({
            currentSort: nextSort,
        });

    };

    render() {
        return (
            <>
                <div className="table-componet">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="tab__content">
                                <table className="table box-table">
                                    <thead>
                                        <tr>
                                            <th scope="col">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={this.state.MasterChecked}
                                                    id="mastercheck"
                                                    onChange={(e) => this.onMasterCheck(e)}
                                                />
                                            </th>
                                            <th scope="col">Event ID</th>
                                            <th scope="col" className="serialT">Wallbox Serial</th>
                                            <th onClick={this.onSortChange} scope="col" className="id">
                                                <span className="d-installed">Start Timestamp  <BsArrowUp /></span>
                                            </th>
                                            <th scope="col" className="FirmwareT">End Timestamp</th>
                                            <th scope="col" className="Energy_T">Duration </th>
                                            <th scope="col" className="Energy_T">Energy </th>
                                            <th scope="col" className="ownerT">User </th>
                                            <th scope="col" className="ownerT">Konto </th>
                                            <th scope="col" className="statusT">Status</th>
                                            <th scope="col" className="actionsT">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sortedList(this.state.List, this.state.currentSort, 'id').map((user) => (
                                            <tr key={user.id} className={user.selected ? "selected" : ""}>
                                                <th scope="row">
                                                    <input
                                                        type="checkbox"
                                                        checked={user.selected}
                                                        className="form-check-input"
                                                        id="rowcheck{user.id}"
                                                        onChange={(e) => this.onItemCheck(e, user)}
                                                    />
                                                </th>

                                                <td className="eventID"><span>{user.id}</span></td>
                                                <td className="wallboxSerial"><span><Link to="/chargeEvents">{user.wallboxSerial}</Link></span></td>
                                                <td className="Date__Time"><span>{user.Dateinstalled} <time>{user.timeD}</time></span></td>
                                                <td className="Date__Time"><span>{user.endDate} <time>{user.endTime}</time></span></td>
                                                <td className="duration"><span>{user.duration}</span></td>
                                                <td className="duration"><span>{user.energy}</span></td>
                                                <td className="Owner"><span>{user.User}</span></td>
                                                <td className="Owner"><span>{user.Konto}</span></td>
                                                <td className="Stat"><span className={user.Status}>{user.Status}</span></td>
                                                <td className="Actions">
                                                    <span>
                                                        {
                                                            user.Status !== "Finished" && <button><img alt="" src={update} /> Update</button>
                                                        }
                                                        <button><img alt="" src={search} /></button>
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="pagination-content">
                        <ul>
                            <li>1</li>
                            <li className="active">2</li>
                            <li>3</li>
                            <li>4</li>
                            <li><BsChevronDoubleRight /></li>
                        </ul>
                        <div className="pageRight">
                            <span>Showing 20 of 320 items</span>
                        </div>
                    </div>
                </div>

            </>
        );
    }
}

export default ChargeEventData;